import React from "react";
import "./Footerhero.css";

export default function Footerhero() {
  // ✅ Professional consulting-style image (boardroom / strategy session)
  const bgImage =
    "/Footerhero.webp";

  return (
    <section className="footerhero" aria-labelledby="footerhero-title">
      {/* Background image via React */}
      <div
        className="footerhero__bg"
        aria-hidden="true"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      />

      {/* Overlay + content */}
      <div className="footerhero__overlay">
        <div className="footerhero__content">
          <h2 id="footerhero-title" className="footerhero__title">
            <span className="footerhero__title-line1">Strengthening Communities,</span>
            <span className="footerhero__title-line2">Supporting Fathers, Building a Brighter Future</span>
          </h2>

          <p className="footerhero__subtitle">
            Community Impact Solutions LLC provides the powerful combination of lived experience, professional training, and leadership expertise to every project it takes on.
          </p>

          <a className="footerhero__btn" href="/contact">
            REQUEST A CONSULTATION
          </a>
        </div>
      </div>
    </section>
  );
}